module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-3-Media-Whats-the-Influence-ES-81eb483e22f43ff9d5bf700ec9fa85a8.pdf";